<template>
  <div class="inline-box">
    <span @click="handleSwitch">
      <el-tooltip effect="dark" content="打开可查看脱敏信息" placement="bottom">
        <svg-icon :icon-class="isShowPhone ? 'EyeOn' : 'EyeOff'"  style="cursor: pointer"  />
      </el-tooltip>
    </span>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
export default {
  name: "EyePhone",
  computed: {
    ...mapGetters(["isShowPhone"]),
  },
  methods: {
    ...mapMutations({
      SET_IS_SHOW_PHONE: "app/SET_IS_SHOW_PHONE",
    }),
    handleSwitch() {
      this.SET_IS_SHOW_PHONE(!this.isShowPhone);
    },
  },
};
</script>

<style lang="scss" scoped>
.inline-box {
  display: inline-block;
  padding: 0 8px;
  font-size: 20px;
  vertical-align: text-bottom;
}
</style>